import { Routes } from '@/routes';

export default {
	'organisation.index': () => import('@/modules/organisations/index'),
	'organisation.new': () => import('@/modules/organisations/form'),
	'organisation.edit': () => import('@/modules/organisations/form'),
	'organisation.show': () => import('@/modules/organisations/show'),
	'my-organisation.index': () => import('@/modules/organisations/my-organisation-index'),
	'my-organisation.show': () => import('@/modules/organisations/my-organisation-show'),
} as Routes;
